import { defineMessages } from '@formatjs/intl';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import ErrorBoundary from '../../ErrorBoundary';

import { InvitationList } from '.';

export const InvitationTab: React.FC = () => {
  const intl = useIntl();
  const header = defineMessages({
    invitationheader: {
      id: 'builder.reception.invitation.header',
      defaultMessage: 'Deine Einladungen an Coachees',
    },
  });

  return (
    <Box sx={{ padding: '0 1rem' }}>
      <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <Typography variant="h5">
          {intl.formatMessage(header.invitationheader)}
        </Typography>
      </Box>
      <div style={{ height: '60vh' }}>
        <ErrorBoundary>
          <InvitationList />
        </ErrorBoundary>
      </div>
    </Box>
  );
};
